import { render, staticRenderFns } from "./DoWhat.vue?vue&type=template&id=3ac8a7b1&scoped=true&"
import script from "./DoWhat.vue?vue&type=script&lang=js&"
export * from "./DoWhat.vue?vue&type=script&lang=js&"
import style0 from "./DoWhat.vue?vue&type=style&index=0&id=3ac8a7b1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac8a7b1",
  null
  
)

export default component.exports